import React from 'react'
import './Chef.css';
import Subheading from '../../components/SubHeading/Subheading'
import MenuItem from '../../components/Menuitem/MenuItem.jsx'

import { images, data } from '../../constants';
const Chef = () => {
  return (
    <div className='app__bg app__wrapper section__padding' style={{ backgroundColor: 'var(--color-teal' }}>
      <div className='app__wrapper_img app__wrapper_img-reverse'>
        <img src={images.chef} alt='chef' />
      </div>

      <div className='app__wrapper_info' style={{ color: 'white' }}>
        <Subheading title="Chef's word" />
        <hr></hr>
        <h1 className="headtext__cormorant">What we believe in</h1>

        <div className="app__chef-content">
          <div className="app__chef-content_quote">
            <p className="p__opensans">Lorem ipsum dolor sit amet, consectetur adipiscing elit auctor sit .</p>
          </div>
          <p className="p__opensans"> auctor sit iaculis in arcu. Vulputate nulla lobortis mauris eget sit. Nulla scelerisque scelerisque congue ac consequat, aliquam molestie lectus eu. Congue iaculis integer curabitur semper sit nunc. </p>
        </div>

        <br></br>
        <div className="app__chef-sign">
          <p>Kevin Luo</p>
          <p className="p__opensans">Chef & Founder</p>
        </div>

      </div>
    </div>
  )
}

export default Chef